/**
 * 通知相關類型定義
 */

/**
 * 通知類型枚舉
 */
export enum NotificationType {
  // 組織管理
  OrganizationInvitation = 'organization_invitation',
  OrganizationMemberJoined = 'organization_member_joined',
  OrganizationMemberRemoved = 'organization_member_removed',
  OrganizationRoleChanged = 'organization_role_changed',

  // 支付與訂閱
  PaymentSuccess = 'payment_success',
  PaymentFailed = 'payment_failed',
  SubscriptionCreated = 'subscription_created',
  SubscriptionRenewed = 'subscription_renewed',
  SubscriptionCancelled = 'subscription_cancelled',
  SubscriptionExpiringSoon = 'subscription_expiring_soon',
  InvoiceGenerated = 'invoice_generated',
  WalletRecharged = 'wallet_recharged',
  WalletLowBalance = 'wallet_low_balance',

  // Feedback 反饋
  FeedbackCommented = 'feedback_commented',
  FeedbackReplied = 'feedback_replied',
  FeedbackStatusChanged = 'feedback_status_changed',
  FeedbackMerged = 'feedback_merged',
  FeedbackPatchReady = 'feedback_patch_ready',
  FeedbackPatchFailed = 'feedback_patch_failed',

  // 用戶安全
  Welcome = 'welcome',
  PasswordResetSuccess = 'password_reset_success',
  TwoFactorEnabled = '2fa_enabled',
  TwoFactorDisabled = '2fa_disabled',
  UnusualLogin = 'unusual_login',

  // 業務處理
  AiAppPublished = 'ai_app_published',
  DatasourceProcessed = 'datasource_processed',
  DatasourceFailed = 'datasource_failed',

  // OAuth 授權
  OauthAppAuthorized = 'oauth_app_authorized',
  OauthAppRevoked = 'oauth_app_revoked',

  // 系統
  System = 'system',
  Announcement = 'announcement',
}

export interface Notification {
  uuid: string;
  type: NotificationType | string;
  title: string;
  content: string;
  sender_user_id: number;
  sender_name: string;
  sender_avatar: string | null;
  related_type: string | null;
  related_uuid: string | null;
  related_url: string | null;
  metadata: string | null;
  is_read: boolean;
  read_at: number;
  is_archived: boolean;
  archived_at: number;
  created_at: number;
}

export interface NotificationPagination {
  page: number;
  page_size: number;
  total_count: number;
  total_pages: number;
}

export interface NotificationListResponse {
  notifications: Notification[];
  pagination: NotificationPagination;
}

export interface UnreadCountResponse {
  unread_count: number;
}

export interface MarkReadRequest {
  uuids: string[];
}

export interface MarkReadResponse {
  success_count: number;
  failed_count: number;
  failed_uuids: string[];
}

export interface DeleteNotificationsRequest {
  uuids: string[];
}

export interface DeleteNotificationsResponse {
  success_count: number;
  failed_count: number;
  /** 僅在 failed_count > 0 時由後端回傳 */
  failed_uuids?: string[];
}

export interface ArchiveNotificationsRequest {
  uuids: string[];
}

export interface ArchiveNotificationsResponse {
  success_count: number;
  failed_count: number;
  /** 僅在 failed_count > 0 時由後端回傳 */
  failed_uuids?: string[];
}

export interface NotificationSettings {
  user_id: number;
  platform: string;
  workspace_uuid: string | null;
  enabled_types: string[];
  disabled_types: string[];
  updated_at: number;
}

export interface UpdateNotificationSettingsRequest {
  platform: string;
  enabled_types: string[];
  disabled_types: string[];
}

export interface GetNotificationsParams {
  platform: string;
  type?: string;
  is_read?: boolean;
  is_archived?: boolean;
  page?: number;
  page_size?: number;
}
